// extracted by mini-css-extract-plugin
export default {"wrapper":"SetupSteps_wrapper__GD+g4","displayInModal":"SetupSteps_displayInModal__DJwqk","actions":"SetupSteps_actions__FwZuu","stepWrapper":"SetupSteps_stepWrapper__J683h"};